import React from "react";
import { FaLock } from "react-icons/fa";
import Subsection from "../../../HomePage/components/Subsection.jsx";

const ModuleDetailCard = ({
  module,
  completedSubs,
  onSelectSubsection,
  isUnlocked = true,
}) => {
  if (!module) return null;

  return (
    <div className="w-[650px] rounded-[20px] bg-[#000000] shadow-xl">
      <div className="mb-0 px-6 py-3">
        <h3 className="text-lg font-semibold text-[#FFFFFF]">
          <span className="flex items-center gap-2">
            <span className="text-[#54B0AF] font-bold">
              Module {module.order}:
            </span>
            {!isUnlocked && (
              <FaLock className="text-[#f0f0f0] bg-white/10 rounded-full p-1 text-xs" />
            )}
          </span>
          <span className="block mt-1">{module.title}</span>
        </h3>

        {module.description && (
          <p className="mt-1 text-sm text-[#FFFFFF] leading-relaxed">
            {module.description}
          </p>
        )}
      </div>

      {/* ================= SECTIONS ================= */}
      <div className="space-y-6 bg-[#FFFFFF] rounded-b-[20px] p-6">
        <Subsection
          subsections={module.subsections || []}
          completedSubs={completedSubs}
          moduleOrder={module.order}
          onSelectSubsection={onSelectSubsection}
          isUnlocked={isUnlocked}
        />
      </div>
    </div>
  );
};

export default ModuleDetailCard;
